
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import VTextField from 'vuetify/lib/components/VTextField/VTextField';
import Vue, { CreateElement, VNode } from 'vue';
const base = Vue.extend({ mixins: [VTextField] });

export default base.extend({
    name: 'base-text-field',
    props: {
        clearable: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: true
        },
        elevation: {
            type: Number,
            default: 0
        },
        label: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes(): object {
            return {
                ...VTextField.options.computed.classes.call(this),
                'base-text-field': true
            };
        }
    },
    render(h: CreateElement): VNode {
        const textField = h(
            VTextField,
            {
                class: this.classes,
                props: {
                    ...this.$props
                },
                on: this.$listeners,
                scopedSlots: this.$scopedSlots,
                attrs: this.$attrs
            },
            this.$slots.default
        );
        return h('div', { class: 'text-wrapper' }, [
            this.label ? h('div', { class: 'text-title' }, this.label) : null,
            textField
        ]);
    }
});
